import React from "react";
import MangeDashboard from "./MangeDashboard";
import { Link } from "react-router-dom";
import { useState } from "react";
import ConfirmationAuth from "../ConfirmationAuth";
import { useNavigate } from "react-router-dom";





export default function CheckLevelEhraz({level}){


    const [isDialogOpen, setDialogOpen] = useState(true);
    const navigate =  useNavigate()


    const handleCloseDialog = () => {

        setDialogOpen(false);
        navigate('/')
      };
    
      const handleConfirmPurchase = () => {
        setDialogOpen(false);
        navigate('/top-authentication')
    
      };





    return(
        <MangeDashboard>


        <ConfirmationAuth 
        isOpen={isDialogOpen}
        onClose={handleCloseDialog}
        onConfirm={handleConfirmPurchase}
      />






        </MangeDashboard>


    )

}